import { render, staticRenderFns } from "./ViewPriceRegion.vue?vue&type=template&id=5b8916b6&scoped=true"
import script from "./ViewPriceRegion.vue?vue&type=script&lang=js"
export * from "./ViewPriceRegion.vue?vue&type=script&lang=js"
import style0 from "./ViewPriceRegion.vue?vue&type=style&index=0&id=5b8916b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8916b6",
  null
  
)

export default component.exports